import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { FormatNumber } from '../../../../_config/functions/format-number.function';
import { dictionaryPaymentColumn } from '../constants/dictionary-payment-columns.contant';

export const generatePaymentColumns = (handleOpenPaymentVoucher) => {
	return [
		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].payment_date,
			dataIndex: 'createdAt',
			key: 'createdAt',
		},
		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].total_products,
			dataIndex: 'sub_total',
			key: 'sub_total',
			render: (record) => FormatNumber[Enviroment.LANGUAGE].handleFormat(record),
		},

		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].total_delivery,
			dataIndex: 'total_delivery',
			key: 'total_delivery',
			render: (record) => FormatNumber[Enviroment.LANGUAGE].handleFormat(record),
		},
		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].total_general,
			dataIndex: 'total',
			key: 'total',
			render: (record) => FormatNumber[Enviroment.LANGUAGE].handleFormat(record),
		},

		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].payment_way,
			dataIndex: 'payment_method_name',
			key: 'payment_method_name',
			render: (text, record) => {
				// Si existe payment_tracking con payment_voucher_url, mostrar link
				if (record?.payment_tracking?.payment_voucher_url) {
					return (
						<span 
							onClick={() => handleOpenPaymentVoucher(record.payment_tracking.payment_voucher_url)}
							style={{ color: '#1890ff', cursor: 'pointer'}}
						>
							Comprobante de pago
						</span>
					);
				}
				// Si no hay payment_tracking, mostrar el valor normal
				return text;
			},
		},

		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].pos,
			dataIndex: 'id_transaction',
			key: 'id_transaction',
		},
		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].token,
			dataIndex: 'token',
			key: 'token',
		},
	];
};
